import { render, staticRenderFns } from "./ManuallyEscalateButtons.vue?vue&type=template&id=b9fabdc6"
import script from "./ManuallyEscalateButtons.vue?vue&type=script&lang=js"
export * from "./ManuallyEscalateButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports